





















































































































import BackgroundFilesGetListResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundFilesGetListResponse";
import BreathingTranslateViewModel from "@models/breathing/breathingTranslateViewModel";
import CreateBreathingViewModel from "@models/breathing/createBreathingViewModel";
import { Vue, Component } from "vue-property-decorator";

@Component
export default class CreateBreathingComponent extends Vue {
  languages: string[] = [];
  isLoading = false;
  inited = false;
  get title(): string {
    return this.id ? "Редактирование дыхания" : "Добавление дыхания";
  }
  get id(): number {
    const routeId = this.$route.params.id;
    return routeId ? Number(routeId) : 0;
  }
  vm: CreateBreathingViewModel = new CreateBreathingViewModel();
  onBackgroundFileChanged(item: BackgroundFilesGetListResponse) {
    this.vm.backgroundFileUrl = item?.Url || null;
  }
  async created() {
    this.languages = await this.$cacheProvider.getLanguagesAsync();
    this.vm.translations = this.languages.map(
      (x) =>
        new BreathingTranslateViewModel({
          langCode: x,
        })
    );
    if (this.$route.params.id) {
      await this.fetchData();
    }
    this.inited = true;
  }
  async fetchData() {
    this.isLoading = true;
    const res = await this.$api.BreathingService.getDetailAsync(this.id);
    this.vm.fromServerModel(res);
    this.isLoading = false;
  }
  async save() {
    const isValid = (this.$refs.validator as any).isValid();
    if (!isValid) return;
    this.isLoading = true;
    const request = this.vm.toServerModel();
    const res = await this.$api.BreathingService.updateAsync(request);
    if (res) {
      this.$dialog.success("Дыхание успешно обновлено");
      this.$router.back();
    }
    this.isLoading = false;
  }
}
